// import FloorplanView from "../Classes/FloorplanView";

/*
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */
export let DrawingController = {
  animating: false,
  animationSpeed: 0.3, // seconds
  movefactor: 2, // percent
  initialX: 0,
  initialY: 0,
  initialZoom: 1,
  maxzoom: document.body.classList.contains("desktop-browser") ? 12 : 20, // max scale
  minzoom: 1, // min scale
  zoomStepMin: 0.02,
  svg: null,
  svgContainer: null,
  svgWrapper: null,

  initialPosition: function (animate = false) {
    if (this.svg) {
      // get initial zoom from settings
      this.initialZoom = this.svgWrapper.hasAttribute("data-initial-zoom")
        ? this.svgWrapper.dataset.initialZoom
        : this.initialZoom;

      // get centered position
      this.initialX =
        (this.svgContainer.offsetWidth -
          this.svgContainer.offsetWidth * this.initialZoom) /
        2;
      this.initialY =
        (this.svgContainer.offsetHeight -
          this.svgContainer.offsetHeight * this.initialZoom) /
        2;

      // get initial X from settings
      this.initialX =
        this.svgWrapper.hasAttribute("data-initial-translate-x") &&
        this.svgWrapper.dataset.initialTranslateX != ""
          ? this.svgWrapper.dataset.initialTranslateX
          : this.initialX;

      // get initial Y from settings
      this.initialY =
        this.svgWrapper.hasAttribute("data-initial-translate-y") &&
        this.svgWrapper.dataset.initialTranslateY != ""
          ? this.svgWrapper.dataset.initialTranslateY
          : this.initialY;

      // move to initial position
      this.moveAndZoom(this.initialX, this.initialY, this.initialZoom, animate);
    }
  },
  zoomIn: function (event = null) {
    const currentZoom = parseFloat(
      this.svgWrapper.getAttribute("data-zoomlevel")
    );

    if (currentZoom >= this.maxzoom) return;

    const multiplicator = currentZoom + this.zoomStepMin;
    const zoom = currentZoom + this.zoomStepMin * multiplicator;

    // centering svg while zoom in
    let translate = null;

    // TODO: Zoom to cursor
    // if (event) {
    //   translate = this.getCursorCenterToZoom(
    //     currentZoom,
    //     zoom,
    //     event
    //   );
    // } else {
    translate = this.getNewMapCenter(currentZoom, zoom);
    // }

    this.moveAndZoom(translate.x, translate.y, zoom);
  },
  zoomOut: function (event = null) {
    const currentZoom = parseFloat(
      this.svgWrapper.getAttribute("data-zoomlevel")
    );
    const multiplicator = currentZoom + this.zoomStepMin;
    const zoom = currentZoom - this.zoomStepMin * multiplicator;

    if (zoom <= this.minzoom) return;

    // centering svg while zoom in
    let translate = null;

    // TODO: Zoom to cursor
    // if (event) {
    //   translate = this.getCursorCenterToZoom(
    //     currentZoom,
    //     zoom,
    //     event
    //   );
    // } else {
    translate = this.getNewMapCenter(currentZoom, zoom);
    // }

    this.moveAndZoom(translate.x, translate.y, zoom);
  },
  panUp: function () {
    this.moveAndZoom(
      this.svgWrapper.offsetLeft,
      this.svgWrapper.offsetTop - this.movefactor,
      this.svgWrapper.getAttribute("data-zoomlevel")
    );
  },
  panDown: function () {
    this.moveAndZoom(
      this.svgWrapper.offsetLeft,
      this.svgWrapper.offsetTop + this.movefactor,
      this.svgWrapper.getAttribute("data-zoomlevel")
    );
  },
  panLeft: function () {
    this.moveAndZoom(
      this.svgWrapper.offsetLeft - this.movefactor,
      this.svgWrapper.offsetTop,
      this.svgWrapper.getAttribute("data-zoomlevel")
    );
  },
  panRight: function () {
    this.moveAndZoom(
      this.svgWrapper.offsetLeft + this.movefactor,
      this.svgWrapper.offsetTop,
      this.svgWrapper.getAttribute("data-zoomlevel")
    );
  },
  moveAndZoom: function (vx, vy, scale = 1, animate = false) {
    if (this.animating) return;

    // Check postion inside container
    const wrapperBounding = this.svgWrapper.getBoundingClientRect();
    const containerBounding = this.svgContainer.getBoundingClientRect();

    // get container and svg boundings
    const divLeftBounding = containerBounding.left - wrapperBounding.left;
    const divRightBounding = wrapperBounding.right - containerBounding.right;
    const divTopBounding = containerBounding.top - wrapperBounding.top;
    const divBottomBounding = wrapperBounding.bottom - containerBounding.bottom;

    // get current translate3d values
    const currentTranslate = {
      x: this.svgWrapper.offsetLeft,
      y: this.svgWrapper.offsetTop,
    };

    // parse to int (if data-Attribute)
    scale = parseFloat(scale);
    const currentZoom = parseFloat(this.svgWrapper.dataset.zoomlevel) ?? 1;

    // prevent dragging over bounding on x axis
    if (
      currentZoom == scale &&
      ((divLeftBounding < 0 && vx >= currentTranslate["x"]) ||
        (divRightBounding < 0 && vx <= currentTranslate["x"]))
    ) {
      vx = currentTranslate["x"];
    }

    // prevent dragging over bounding on y axis
    if (
      currentZoom == scale &&
      ((divTopBounding < 0 && vy >= currentTranslate["y"]) ||
        (divBottomBounding < 0 && vy <= currentTranslate["y"]))
    ) {
      vy = currentTranslate["y"];
    }

    // activate animation
    if (animate) {
      const that = this;
      that.animating = true;
      const speedmodifier = 0.05 * scale;
      const speed = this.animationSpeed + speedmodifier;

      this.svgWrapper.style.transition = "all " + speed + "s linear";

      setTimeout(function () {
        that.animating = false;
        that.svgWrapper.style.transition = "";
      }, 1000 * speed);
    }

    this.svgWrapper.setAttribute("data-zoomlevel", scale);
    this.svgWrapper.setAttribute("data-zoomlevel-logos", Math.floor(scale));

    this.svgWrapper.style.width = this.svgContainer.offsetWidth * scale + "px";
    this.svgWrapper.style.height =
      this.svgContainer.offsetHeight * scale + "px";

    // this.svgWrapper.style.transform =
    //   "translate3d(" + vx + "px, " + vy + "px, 0)";

    this.svgWrapper.style.left = vx + "px";
    this.svgWrapper.style.top = vy + "px";
  },

  /*--------------- Getter ------------- */
  getCursorCenterToZoom: function (currentZoom, targetZoom, event) {
    const svgContainerBounding = this.svgContainer.getBoundingClientRect();
    // const storeRectBounding = target.getBoundingClientRect();
    const cursorBounding = {
      left: event.clientX,
      top: event.clientY,
    };

    /**
     * Before Zoom
     */
    const absoluteCenterBeforeZoomX =
      (this.svgContainer.offsetWidth - this.svgWrapper.offsetWidth) / 2;
    const absoluteCenterBeforeZoomY =
      (this.svgContainer.offsetHeight - this.svgWrapper.offsetHeight) / 2;

    const storeToCenterX =
      this.svgContainer.offsetWidth / 2 +
      this.svgWrapper.offsetLeft -
      (cursorBounding.left - svgContainerBounding.left);
    const storeToCenterY =
      this.svgContainer.offsetHeight / 2 +
      this.svgWrapper.offsetTop -
      (cursorBounding.top - svgContainerBounding.top);

    const diffToAbsoluteCenterBeforeZoomX =
      absoluteCenterBeforeZoomX - storeToCenterX;
    const diffToAbsoluteCenterBeforeZoomY =
      absoluteCenterBeforeZoomY - storeToCenterY;

    // After Zoom
    const absoluteCenterAfterZoomX =
      (this.svgContainer.offsetWidth -
        this.svgContainer.offsetWidth * targetZoom) /
      2;
    const absoluteCenterAfterZoomY =
      (this.svgContainer.offsetHeight -
        this.svgContainer.offsetHeight * targetZoom) /
      2;

    const diffToAbsoluteCenterAfterZoomX =
      (diffToAbsoluteCenterBeforeZoomX / currentZoom) * targetZoom;
    const diffToAbsoluteCenterAfterZoomY =
      (diffToAbsoluteCenterBeforeZoomY / currentZoom) * targetZoom;

    return {
      x: absoluteCenterAfterZoomX - diffToAbsoluteCenterAfterZoomX,
      y: absoluteCenterAfterZoomY - diffToAbsoluteCenterAfterZoomY,
      z: targetZoom,
    };
  },
  getNewMapCenter: function (currentZoom, targetZoom) {
    // Before Zoom
    const absoluteCenterBeforeZoomX =
      (this.svgContainer.offsetWidth - this.svgWrapper.offsetWidth) / 2;
    const absoluteCenterBeforeZoomY =
      (this.svgContainer.offsetHeight - this.svgWrapper.offsetHeight) / 2;

    const realCenterBeforeZoomX = this.svgWrapper.offsetLeft;
    const realCenterBeforeZoomY = this.svgWrapper.offsetTop;

    const diffToAbsoluteCenterBeforeZoomX =
      absoluteCenterBeforeZoomX - realCenterBeforeZoomX;
    const diffToAbsoluteCenterBeforeZoomY =
      absoluteCenterBeforeZoomY - realCenterBeforeZoomY;

    // After Zoom
    const absoluteCenterAfterZoomX =
      (this.svgContainer.offsetWidth -
        this.svgContainer.offsetWidth * targetZoom) /
      2;
    const absoluteCenterAfterZoomY =
      (this.svgContainer.offsetHeight -
        this.svgContainer.offsetHeight * targetZoom) /
      2;

    const diffToAbsoluteCenterAfterZoomX =
      (diffToAbsoluteCenterBeforeZoomX / currentZoom) * targetZoom;
    const diffToAbsoluteCenterAfterZoomY =
      (diffToAbsoluteCenterBeforeZoomY / currentZoom) * targetZoom;

    return {
      x: absoluteCenterAfterZoomX - diffToAbsoluteCenterAfterZoomX,
      y: absoluteCenterAfterZoomY - diffToAbsoluteCenterAfterZoomY,
    };
  },
};
